import { useMemo, useState } from 'react';

import { FormSubmit } from 'libs/form';
import { useTranslation } from 'libs/i18n';
import { useSystemSettingsContext } from 'libs/providers';

import { OnboardingSettingsFormType } from '../forms/onboardingSettingsForm';
import { getInitialValue, getSubmitData } from '../helpers';

export const useOnboardingSettings = () => {
  const { t } = useTranslation();

  const [submitLoading, setSubmitLoading] = useState(false);

  const { settings, saveSettings } = useSystemSettingsContext();

  const initialValues = useMemo(
    () => getInitialValue(t, settings),
    [settings, t]
  );

  const onSubmit: FormSubmit<OnboardingSettingsFormType> = async (
    values,
    helpers
  ) => {
    setSubmitLoading(true);
    try {
      const data = getSubmitData(values);
      await saveSettings({ ...settings, ...data });
    } catch (error) {
      /* empty */
    }
    helpers.setReadOnly(true);
    setSubmitLoading(false);
  };

  return {
    settings,
    initialValues,
    submitLoading,
    onSubmit,
  };
};
